import { createSelector } from 'reselect';
import { AppState } from '../reducers';
import { SiteState } from '../reducers/site.reducer';

const siteState = (state: AppState): SiteState => state.site;

export namespace SiteSelectors {
  export const isFetching = createSelector(
    [siteState],
    (state: SiteState) => state.isFetching,
  );

  export const getSiteBrowseInfo = createSelector(
    [siteState],
    (state: SiteState) => state.siteBrowse,
  );

  export const getCurrentSite = createSelector(
    [siteState],
    (state: SiteState) => state.currentSite,
  );

  export const getSiteInformationTabInfo = createSelector(
    [siteState],
    ({
      currentSite,
      activeOrAuthorizedProjectsCount,
      hasActiveOrAuthorizedProjects,
    }: SiteState) => ({
      currentSite,
      activeOrAuthorizedProjectsCount,
      hasActiveOrAuthorizedProjects,
    }),
  );

  export const getSiteContactsInfo = createSelector(
    [siteState],
    (state: SiteState) => state.siteContacts,
  );

  export const getSiteAssociatedProjectsInfo = createSelector(
    [siteState],
    ({ currentSite, associatedProjects }: SiteState) => ({
      currentSite,
      associatedProjects,
    }),
  );

  export const getTabLoadingState = (tabName: string) =>
    createSelector(
      [siteState],
      (state: SiteState) => state.loadingTabs[tabName] || false,
    );

  export const getTabLoadedState = (tabName: string) =>
    createSelector(
      [siteState],
      (state: SiteState) => state.loadedTabs[tabName] || false,
    );

  export const getTabErrorState = (tabName: string) =>
    createSelector(
      [siteState],
      (state: SiteState) => state.tabErrors[tabName] || false,
    );

  export const getCreatedSiteUniqueFields = createSelector(
    [siteState],
    (state: SiteState) => state.createdSiteUniqueFields,
  );

  export const getPSLocationCodeOptions = createSelector(
    [siteState],
    (state: SiteState) => state.PSLocationCodeOptions,
  );

  export const getMDGLocationCodeOptions = createSelector(
    [siteState],
    (state: SiteState) => state.MDGLocationCodeOptions,
  );
}
